import api from '@/shared/api/api-client';

import type { ApiKey } from '../../_shared/domain/api-key.model';
import type { ApiKeysGateway } from './api-keys.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the API keys index endpoints (kept 1:1 with the original `ApiKeys` page's
 * `/api-keys` GET / POST / DELETE). The POST returns the raw secret only once;
 * this unwraps it to the `key` string the saga stores for the "copy now" dialog.
 */
export const httpApiKeysGateway: ApiKeysGateway = {
  fetchApiKeys: () => api.get<ApiKey[]>('/api-keys'),
  createApiKey: async (name: string) => {
    const result = await api.post<{ key: string }>('/api-keys', { name: name.trim() });
    return result.key;
  },
  revokeApiKey: async (id: string) => {
    await api.delete(`/api-keys/${id}`);
  },
};
